import { render, staticRenderFns } from "./TermsAndConditionsEn.vue?vue&type=template&id=55f5efde&scoped=true"
import script from "./TermsAndConditionsEn.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5efde",
  null
  
)

export default component.exports